<template>
    <v-row>
        <v-col cols="9" sm="10" offset-sm="1" offset="1" class="pr-0 text-right">
            <message-bubble from="me" :message="message"/>
        </v-col>
        <v-col cols="2" sm="1" align="left">
            <v-avatar size="32">
                <v-img :lazy-src="imgPlaceholder" cover :src="img" class="borderImg"/>
            </v-avatar>
        </v-col>
    </v-row>
</template>

<script>

import MessageBubble from "@/components/common/chat/MessageBubble";

export default {
    components: {
        MessageBubble,
    },
    props: {
        message: {
            type: Object,
            default: null,
        },
        img: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: 'grey',
        }
    },
}
</script>

<style scoped>

.borderImg {
    border: 1px solid var(--v-primary-base);
}

</style>